module.exports = __webpack_public_path__ + "img/activeSet5.1fe681ab.png";